import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalizefirstletter',
    standalone: false
})
export class CapitalizeFirstLetter implements PipeTransform {
	transform(value: string, args?: any): any {
		if (!value) {
			return '';
		}
		const lower = value.toLowerCase();
		return lower.replace(/(^|[^A-Za-z0-9]| )(\w)/g, function(x) {
			return x.toUpperCase();
		});
	}
}
